export function getProfessionalGridSurface(isDark: boolean): string {
  if (isDark) return 'rgba(107,78,113,0.10)';
  return 'rgba(245,245,247,0.72)';
}
